"use es6";

export var skipToken = Symbol.for("apollo.skipToken");